import { render, staticRenderFns } from "./spGrayLayer.vue?vue&type=template&id=4c980968&scoped=true&"
import script from "./spGrayLayer.vue?vue&type=script&lang=js&"
export * from "./spGrayLayer.vue?vue&type=script&lang=js&"
import style0 from "./spGrayLayer.vue?vue&type=style&index=0&id=4c980968&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c980968",
  null
  
)

export default component.exports